<template>
  <v-container fluid class="py-5 px-5 py-sm-15 px-sm-10 align-start">
    <v-row>
      <v-col cols="12" :md="createOrUpdateOrganization ? 7 : 12" style="transition: all 0.3s ease;">
        <v-row align="center">
          <v-col cols="12" sm="auto" class="text-start">
            <span class="textLight--text font-weight-bold text-h4">
              {{ $t("organization.organizations") }}
            </span>
          </v-col>

          <v-spacer />

          <v-col
            v-if="havePermissionCreateOrganization"
            cols="12"
            sm="3"
            md="4"
            lg="2"
          >
            <v-btn
              depressed
              min-height="48"
              block
              color="primary"
              style="text-transform: unset; letter-spacing: 0.5px;"
              class="rounded-lg font-weight-medium elevation-2"
              @click="addNew"
            >
              <v-icon left> mdi-plus </v-icon>
              {{ $t("organization.add") }}
            </v-btn>
          </v-col>

          <v-col cols="12" sm="12" md="4" lg="4">
            <v-text-field
              v-model="search"
              hide-details
              prepend-inner-icon="mdi-magnify"
              color="primary"
              background-color="#F8F8F8"
              :placeholder="$t('course.search')"
              solo
              flat
              clearable
              class="shrink rounded-lg"
              style="border: 1px solid #EBEBEB;"
            />
          </v-col>

          <v-col cols="12" sm="3" md="4" lg="2">
                <v-menu>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      :disabled="loading"
                      outlined
                      block
                      style="text-transform: unset;"
                      class="rounded-lg textLight--text font-weight-medium button"
                      height="48"
                      v-bind="attrs"
                      v-on="on"
                      :loading="exportBtnLoading"
                    >
                      <v-icon left>mdi-export</v-icon>
                      {{ $t("reports.export") }}
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(item, i) in exportItems"
                      :key="i"
                      class="hand-cursor"
                    >
                      <v-list-item-title @click="exportTo(item.value)">
                        <div class="d-flex align-center justify-space-between">
                          {{ item.text }}
                          <v-icon
                            size="25"
                            :color="item.iconColor"
                            class="ms-2"
                            >{{ item.icon }}</v-icon
                          >
                        </div>
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row class="mt-10">
      <v-col cols="12" :md="createOrUpdateOrganization ? 7 : 12" order="2" order-md="1" style="transition: all 0.3s ease;">
        <v-row>
          <v-col cols="12">
            <organization-list
              :data="organizations"
              :loading="loading"
              @editOrganizationVal="editOrganizationVal"
              @reFetch="refetch"
              @responseErr="errResponse"
            />
          </v-col>

          <!-- <v-col cols="12" v-if="organizations && organizations.length">
            <div class="d-flex justify-end textLight--text subtitle-2">
              <p
                class="ma-0"
                style="cursor: pointer"
                v-if="pageInput.skip"
                @click="onClickPrev"
              >
                Prev
              </p>

              <p
                class="ma-0 ms-5"
                style="cursor: pointer"
                v-if="
                  totalCount > pageInput.skip + pageInput.limit &&
                  totalCount > pageInput.limit
                "
                @click="onClickNext"
              >
                Next
              </p>
            </div>
          </v-col> -->
        </v-row>
      </v-col>

      <v-col cols="12" md="5" order="1" order-md="2">
        <create-or-update-organization
          v-if="createOrUpdateOrganization"
          :isCreate="isCreate"
          :organizationData="editData"
          @close="createOrUpdateOrganization = null"
          @onOrganizationCreate="afterCreate"
        />
      </v-col>
    </v-row>

    <v-snackbar v-model="snackbarSuccess" timeout="3000" color="success">
      {{
        snackbarSuccessMessage || $t("course.courseDetails.successfullySave")
      }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="primary"
          text
          v-bind="attrs"
          @click="snackbarSuccess = false"
        >
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>

    <v-snackbar v-model="snackbarError" timeout="3000" color="error">
      {{ snackbarErrorMessage || $t("somethingWentWrong") }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="primary"
          text
          v-bind="attrs"
          @click="snackbarError = false"
        >
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>
<script>
import OrganizationList from "../components/OrganizationsList.vue";
import CreateOrUpdateOrganization from "../components/CreateOrUpdateOrganization.vue";

import { hasPermission } from "@/app/user-module/helpers/authHelper";
import { excelExport } from "../../reports-module/methods/excelExport";

const defaultPageInput = () => ({
  skip: 0,
  limit: 0,
});

export default {
  components: {
    OrganizationList,
    CreateOrUpdateOrganization,
  },
  data() {
    return {
      search: null,
      loading: true,
      organizationsOg: [],
      organizations: [],
      totalCount: null,
      pageInput: defaultPageInput(),
      filterInput: null,
      debounceSearch: null,
      editData: {},
      createOrUpdateOrganization: null,
      isCreate: null,
      snackbarSuccess: false,
      snackbarError: false,
      snackbarSuccessMessage: null,
      snackbarErrorMessage: null,
      exportBtnLoading: false,
      exportItems: [
        {
          value: "xl",
          text: this.$t("reports.exportTo"),
          icon: "mdi-microsoft-excel",
          iconColor: "success",
        },
        // {
        //   value: "pdf",
        //   text: this.$t("reports.exportTo"),
        //   icon: "mdi-file-pdf-box",
        //   iconColor: "error",
        // },
      ],
    };
  },
  apollo: {
    getOrganizations() {
      return {
        query: require("../api/query/getOrganizations.gql"),
        variables: {
          ...this.pageInput,
          filterInput: this.filterInput,
        },
        result({ data, loading }) {
          if (
            data &&
            data.getOrganizations &&
            data.getOrganizations.organizations
          ) {
            this.organizationsOg = data.getOrganizations.organizations;
            this.organizations = this.organizationsOg;
            this.totalCount = data.getOrganizations.totalCount;
          }

          this.loading = loading;
        },
      };
    },
  },
  watch: {
    search() {
      clearTimeout(this.debounceSearch);

      this.debounceSearch = setTimeout(() => {
        // TODO: search from api not need now, do later if need.
        // this.apiSearch();
        this.localSearch();
      }, 500);
    },
  },
  computed: {
    havePermissionCreateOrganization() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["CREATE_ORGANIZATION"],
        restrictOrganizationManager:
          this.$store.state.authenticatedUser?.isOrganizationManager,
      });
    },
  },
  methods: {
    async exportTo(val) {
      if (val === "xl") {
        this.exportBtnLoading = true;
        this.localSearch();

        let exportArr = this.organizations.map(organization => {
          let obj = {};
          obj[this.$t("user.registration.name")] = organization?.name.length
            ? this.getLocalisedValue(organization?.name)
            : " - ";
          obj[this.$t("user.email")] = organization?.email
            ? organization.email
            : " - ";
          obj[this.$t("user.phone")] = organization?.phone
            ? organization.phone
            : " - ";
          obj[this.$t("organization.contactName")] = organization?.contactName
            ? organization.contactName
            : " - ";
          obj[this.$t("statistics.totalEmployees")] =
            organization?.totalEmployees ? organization.totalEmployees : " - ";
          return obj;
        });
        this.exportBtnLoading = false;
        let name = "organizations";
        let fileName = name.concat("-", this.$moment().unix());
        excelExport(exportArr, fileName);
      }
    },
    apiSearch() {
      const searchText = this.search?.trim() ?? "";

      if (searchText.length > 3) {
        this.pageInput = defaultPageInput();
        this.filterInput = { search: searchText };
        this.refetch();
      } else if (searchText.length === 0 && this.filterInput?.search != null) {
        this.pageInput = defaultPageInput();
        this.filterInput = null;
        this.refetch();
      }
    },
    localSearch() {
      const searchText = this.search?.trim()?.toLowerCase() ?? "";

      if (searchText.length > 2) {
        this.organizations = this.organizationsOg.reduce((result, item) => {
          if (
            item.name?.findIndex(
              x =>
                x.value?.toLowerCase()?.indexOf(searchText.toLowerCase()) >= 0
            ) >= 0
          ) {
            result.push(item);
          }

          return result;
        }, []);
      } else if (searchText.length === 0) {
        this.organizations = this.organizationsOg;
      }
    },
    addNew() {
      this.editData = {};
      this.isCreate = true;
      this.createOrUpdateOrganization = true;
    },
    editOrganizationVal(val) {
      if (val) {
        this.editData = val;
        this.isCreate = false;
        this.createOrUpdateOrganization = true;
      }
    },
    onClickNext() {
      this.pageInput.skip += this.pageInput.limit;
      this.refetch();
    },
    onClickPrev() {
      this.pageInput.skip -= this.pageInput.limit;
      this.refetch();
    },
    afterCreate() {
      this.pageInput = defaultPageInput();
      this.filterInput = null;
      this.search = null;

      this.refetch();
    },
    errResponse(msg) {
      if (msg) this.snackbarErrorMessage = msg;
      this.snackbarError = true;
    },
    async refetch() {
      this.createOrUpdateOrganization = false;

      await this.$apollo.queries.getOrganizations.refetch({
        ...this.pageInput,
        filterInput: this.filterInput,
      });
    },
  },
};
</script>
